module.exports = __webpack_public_path__ + "img/발키리.e4038612.png";